import * as types from '../_actions/actionTypes';
import _ from 'lodash';

export function etime(state = {loading: true}, action) {
  switch (action.type) {
    case types.FETCH_CURRENT_USER_ETIME:
      return { ...state, ...action.payload, loading: false };
    case types.UPDATE_ETIME:
      return _.merge({}, state, action.payload);
    case types.REMOVE_ETIME:
      return { events: _.omit(state.events, action.payload) };
    case types.FETCH_CURRENT_USER_ETIME_FAILURE:
      return state;
    case types.ADD_ETIME_FAILURE:
      return state;
    case types.UPDATE_ETIME_FAILURE:
      return state;
    case types.REMOVE_ETIME_FAILURE:
      return state;
    default:
      return state;
  }
}

function removeEvent(event, state) {
  const { events } = state;

  const idx = _.findIndex(events, { id: event.id });

  if (idx != -1) {
    const nextEvents = [...events];
    nextEvents.splice(idx, 1);

    return nextEvents;
  } else {
    return [...state.events, event];
  }
}

function updateEvent(event, state) {
  const { events } = state;
  var id = event.ID;

  const idx = events.entities.events[id];

  if (idx) {
    // update existing event
    var eventObj = {};
    eventObj[id] = event;
    const mEntities = _.merge({}, events.entities.events, eventObj);
    return { entities: mEntities, result: events.result };
  } else {
    // append
    var eventObj = {};
    eventObj[id] = event;
    const mEntities = _.merge({}, events.entities.events[id], eventObj);
    const mResult = _.union(events.result, [id]);
    return { entities: mEntities, result: mResult };
  }
  // const idx = _.findIndex(events, { id: event.id });

  // if (idx != -1) {
  //   const nextEvents = [...events];
  //   nextEvents.splice(idx, 1, event);

  //   return nextEvents;
  // } else {
  //   return [...state.events, event];
  // }
}

function addEvent(event, state) {
  return [...state.events, event];
}
